import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "user-asset-form" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-section-title" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = {
  for: "email",
  class: "form-label required"
}
const _hoisted_10 = ["placeholder", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_15 = {
  key: 2,
  class: "text-muted small mt-1"
}
const _hoisted_16 = { class: "col-md-6 mb-3" }
const _hoisted_17 = ["placeholder", "disabled"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6 mb-3" }
const _hoisted_24 = {
  for: "name",
  class: "form-label required"
}
const _hoisted_25 = ["placeholder", "disabled"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "col-md-6 mb-3" }
const _hoisted_30 = {
  for: "surname",
  class: "form-label required"
}
const _hoisted_31 = ["placeholder", "disabled"]
const _hoisted_32 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6 mb-3" }
const _hoisted_37 = {
  for: "phone",
  class: "form-label"
}
const _hoisted_38 = ["placeholder", "disabled"]
const _hoisted_39 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_40 = { class: "form-label" }
const _hoisted_41 = { class: "form-check form-switch" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  for: "isActive",
  class: "form-check-label"
}
const _hoisted_44 = { class: "form-section" }
const _hoisted_45 = { class: "form-section-title" }
const _hoisted_46 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_47 = { class: "form-label" }
const _hoisted_48 = { class: "form-check" }
const _hoisted_49 = {
  for: "role-type-owner",
  class: "form-check-label"
}
const _hoisted_50 = { class: "text-muted d-block mt-2" }
const _hoisted_51 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_52 = { class: "form-label required" }
const _hoisted_53 = { class: "form-check" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  for: "role-type-admin",
  class: "form-check-label"
}
const _hoisted_56 = { class: "form-check mt-2" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  for: "role-type-user",
  class: "form-check-label"
}
const _hoisted_59 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 0,
  class: "form-section"
}
const _hoisted_62 = { class: "form-section-title" }
const _hoisted_63 = { class: "mb-3" }
const _hoisted_64 = {
  for: "user-asset-groups",
  class: "form-label required"
}
const _hoisted_65 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "text-muted" }
const _hoisted_68 = { class: "form-section" }
const _hoisted_69 = { class: "form-section-title" }
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = { class: "form-label" }
const _hoisted_72 = { class: "form-check" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = {
  for: "channel-email",
  class: "form-check-label"
}
const _hoisted_75 = { class: "form-check mt-2" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  for: "channel-sms",
  class: "form-check-label"
}
const _hoisted_78 = { class: "form-check mt-2" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  for: "channel-mercure",
  class: "form-check-label"
}
const _hoisted_81 = { class: "text-muted d-block mt-2" }
const _hoisted_82 = { class: "d-flex justify-content-between w-100" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchicalSelect = _resolveComponent("HierarchicalSelect")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, [
        (_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('components.userAssets.modal.viewTitle')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.userAssets.modal.editTitle') : _ctx.$t('components.userAssets.modal.createTitle')), 1))
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-person me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.basicInfo')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.email')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                  type: "email",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.email.$error || _ctx.emailExists }]),
                  placeholder: _ctx.$t('components.userAssets.modal.placeholders.email'),
                  disabled: _ctx.isReadOnly || _ctx.isEditMode
                }, null, 10, _hoisted_10), [
                  [_vModelText, _ctx.v$.form.email.$model]
                ]),
                (_ctx.v$.form.email.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.v$.form.email.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.emailRequired')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.email.email.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.emailInvalid')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.emailExists && !_ctx.v$.form.email.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.emailExists')), 1))
                  : _createCommentVNode("", true),
                (_ctx.checkingEmail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "spinner-border spinner-border-sm me-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.validation.checkingEmail')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", {
                  for: "password",
                  class: _normalizeClass(["form-label", { required: !_ctx.isEditMode }])
                }, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.password')), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                  type: "password",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.password.$error }]),
                  placeholder: _ctx.$t('components.userAssets.modal.placeholders.password'),
                  disabled: _ctx.isReadOnly,
                  autocomplete: "new-password"
                }, null, 10, _hoisted_17), [
                  [_vModelText, _ctx.v$.form.password.$model]
                ]),
                (_ctx.v$.form.password.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_ctx.v$.form.password.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.passwordRequired')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.password.minLength.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.passwordMinLength', { min: 6 })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isEditMode)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('components.userAssets.modal.hints.passwordOptional')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.name')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.name.$model) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.name.$error }]),
                  placeholder: _ctx.$t('components.userAssets.modal.placeholders.name'),
                  disabled: _ctx.isReadOnly
                }, null, 10, _hoisted_25), [
                  [_vModelText, _ctx.v$.form.name.$model]
                ]),
                (_ctx.v$.form.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_ctx.v$.form.name.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.nameRequired')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.name.minLength.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.nameMinLength', { min: 2 })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.surname')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "surname",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.surname.$model) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.surname.$error }]),
                  placeholder: _ctx.$t('components.userAssets.modal.placeholders.surname'),
                  disabled: _ctx.isReadOnly
                }, null, 10, _hoisted_31), [
                  [_vModelText, _ctx.v$.form.surname.$model]
                ]),
                (_ctx.v$.form.surname.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (_ctx.v$.form.surname.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.surnameRequired')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.surname.minLength.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.surnameMinLength', { min: 2 })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.phone')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "phone",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.phone) = $event)),
                  type: "tel",
                  class: "form-control",
                  placeholder: _ctx.$t('components.userAssets.modal.placeholders.phone'),
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_38), [
                  [_vModelText, _ctx.form.phone]
                ])
              ]),
              (!_ctx.isAssetOwnerEditingSelf)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.status')), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        id: "isActive",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.active) = $event)),
                        type: "checkbox",
                        class: "form-check-input",
                        role: "switch",
                        disabled: _ctx.isReadOnly
                      }, null, 8, _hoisted_42), [
                        [_vModelCheckbox, _ctx.form.active]
                      ]),
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.form.active ? _ctx.$t('components.userAssets.modal.active') : _ctx.$t('components.userAssets.modal.inactive')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h5", _hoisted_45, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-shield-check me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.roles')), 1)
            ]),
            (_ctx.isAssetOwnerEditingSelf)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.roleType')), 1),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[19] || (_cache[19] = _createElementVNode("input", {
                      id: "role-type-owner",
                      type: "checkbox",
                      class: "form-check-input",
                      checked: "",
                      disabled: ""
                    }, null, -1)),
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('components.userAssets.modal.roleTypes.owner') || 'Właściciel'), 1)
                  ]),
                  _createElementVNode("small", _hoisted_50, _toDisplayString(_ctx.$t('components.userAssets.modal.hints.ownerRole') || 'Rola właściciela nie może być zmieniana'), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.roleType')), 1),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      id: "role-type-admin",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.roleType) = $event)),
                      type: "radio",
                      class: "form-check-input",
                      value: "admin",
                      disabled: _ctx.isReadOnly
                    }, null, 8, _hoisted_54), [
                      [_vModelRadio, _ctx.form.roleType]
                    ]),
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('components.userAssets.modal.roleTypes.admin')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      id: "role-type-user",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.roleType) = $event)),
                      type: "radio",
                      class: "form-check-input",
                      value: "user",
                      disabled: _ctx.isReadOnly
                    }, null, 8, _hoisted_57), [
                      [_vModelRadio, _ctx.form.roleType]
                    ]),
                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('components.userAssets.modal.roleTypes.user')), 1)
                  ]),
                  (_ctx.v$.form.roleType.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (_ctx.v$.form.roleType.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.roleTypeRequired')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          (!_ctx.isAssetOwnerEditingSelf)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("h5", _hoisted_62, [
                  _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-diagram-2 me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.groupAssignment')), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.assetGroups')), 1),
                  _createVNode(_component_HierarchicalSelect, {
                    modelValue: _ctx.v$.form.groupIds.$model,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.form.groupIds.$model) = $event)),
                    id: "user-asset-groups",
                    nodes: _ctx.groupTreeOptions,
                    placeholder: _ctx.$t('components.userAssets.modal.noGroupsSelected'),
                    "search-placeholder": _ctx.$t('components.userAssets.modal.searchGroups'),
                    "clear-label": _ctx.$t('components.userAssets.modal.clearGroups'),
                    "no-results-label": _ctx.$t('components.userAssets.modal.noResults'),
                    "no-nodes-label": _ctx.$t('components.userAssets.modal.noGroups'),
                    searchable: true,
                    "allow-null": true,
                    multiple: false,
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["modelValue", "nodes", "placeholder", "search-placeholder", "clear-label", "no-results-label", "no-nodes-label", "disabled"]),
                  (_ctx.v$.form.groupIds.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        (_ctx.v$.form.groupIds.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$t('components.userAssets.modal.validation.groupsRequired')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("small", _hoisted_67, _toDisplayString(_ctx.$t('components.userAssets.modal.hints.assetGroups')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("h5", _hoisted_69, [
              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-bell me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.notificationChannels')), 1)
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('components.userAssets.modal.fields.channels')), 1),
              _createElementVNode("div", _hoisted_72, [
                _withDirectives(_createElementVNode("input", {
                  id: "channel-email",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.notificationChannels.email) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_73), [
                  [_vModelCheckbox, _ctx.form.notificationChannels.email]
                ]),
                _createElementVNode("label", _hoisted_74, [
                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-envelope me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.channels.email')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _withDirectives(_createElementVNode("input", {
                  id: "channel-sms",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.notificationChannels.sms) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_76), [
                  [_vModelCheckbox, _ctx.form.notificationChannels.sms]
                ]),
                _createElementVNode("label", _hoisted_77, [
                  _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-phone me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.channels.sms')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _withDirectives(_createElementVNode("input", {
                  id: "channel-mercure",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.notificationChannels.mercure) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_79), [
                  [_vModelCheckbox, _ctx.form.notificationChannels.mercure]
                ]),
                _createElementVNode("label", _hoisted_80, [
                  _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-broadcast me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.userAssets.modal.channels.mercure')), 1)
                ])
              ]),
              _createElementVNode("small", _hoisted_81, _toDisplayString(_ctx.$t('components.userAssets.modal.hints.notificationChannels')), 1)
            ])
          ])
        ], 32)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.isReadOnly ? _ctx.$t('components.userAssets.modal.close') : _ctx.$t('components.userAssets.modal.cancel')), 1),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.loading,
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_84))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.userAssets.modal.update') : _ctx.$t('components.userAssets.modal.create')), 1)
            ], 8, _hoisted_83))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}